/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import { IoPricetagOutline } from 'react-icons/io5';
import StarIcon from '@mui/icons-material/Star';
import './contactverifier.css';
import parse from 'html-react-parser';
import { LuContact } from 'react-icons/lu';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import axios from 'axios';
import { TbWorld, TbAddressBook, TbMapPinCode, TbBrandLinkedin, TbBriefcase } from 'react-icons/tb';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfiniteScroll from 'react-infinite-scroll-component';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import Key from '../../clientVariables.json';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import ToastMessage from '../../components/ToastMessage';
import Search from '../Searchcontact';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ContactActivity from './ContactActivity';
import UpdateCompanyContact from './UpdateCompanyContact';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from 'react-redux';
import { companiesManagementSelector } from './redux/selector';
import './contactverifier.css';

export const CompanyJobs = ({ companyJobs, getCOmpanyJobs, jobshasmore, selectedJobId, getJobDetail, jobsCount }) => {
  const scrollRef = useRef(null);
  const [email, setEmail] = useState('');

  useEffect(() => { }, []);

  return (
    <div>
      <Card style={{ height: "49px" }}>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-lg-12 jobscolumn" style={{ paddingTop: '8px', paddingLeft: '17px' }}>

            <div className="">
              <div variant="text" style={{ marginTop: '1px', fontWeight: '500', padding: '3px' }}>
                Jobs ({jobsCount}){' '}
                <StarIcon
                  style={{
                    fontSize: 'medium',
                    color: 'rgb(0 0 0 / 70%)',
                    marginLeft: '8px',
                    marginTop: '-2px',
                  }}
                />
              </div>
            </div>

          </div>
        </div>
      </Card>

      <Card>
        {/* <h3 style={{ fontSize: '15px' }}>Compnay contact</h3> */}
        <div ref={scrollRef}>
          <InfiniteScroll
            dataLength={companyJobs?.length}
            next={getCOmpanyJobs}
            hasMore={jobshasmore}
            height={570}
            className='infinityscroll'
            //   className='scroll'
            style={{ overflowY: 'scroll', overflowX: 'hidden' }}
            scrollableTarget="scrollableDiv"
            // refreshFunction={refresh}
            // pullDownToRefresh
            pullDownToRefreshThreshold={50}
          >
            <div className="row">
              {companyJobs?.length > 0 ? (
                companyJobs.map((jobs) => (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      getJobDetail(jobs.id);
                      //   setselectedcontact(contact.ID);
                    }}
                  >
                    <List
                      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                      style={{
                        paddingBottom: '0px',
                        paddingTop: '0px',
                        marginBottom: '0px',
                        // marginTop: '-11px',
                        backgroundColor: selectedJobId === jobs.id ? 'rgba(25, 118, 210, 0.08)' : 'white',
                      }}
                    >
                      <ListItem alignItems="flex-start" className="jobslist">
                        <ListItemAvatar>
                          <Avatar style={{ backgroundColor: 'rgb(169, 169, 169)' }}>
                            <BusinessCenterIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <div>
                              <div>
                                <div className="jobtitle col-12">
                                  <Typography
                                    variant="body2"
                                    style={{ fontSize: '12px', fontWeight: '700', marginTop: '7px' }}
                                    title={jobs?.title}
                                  >
                                    {jobs?.title?.length > 25 ? `${jobs.title.slice(0, 25)}...` : jobs?.title}
                                  </Typography>
                                </div>
                              </div>
                              <p style={{ fontSize: '12px', marginTop: '6px' }}>
                                {' '}
                                {jobs?.jobtypeName?.slice(0, 15) || 'N/A'}
                                {jobs?.jobtypeName?.length > 15 ? '...' : ''}
                                <span
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    marginTop: '-21px',
                                    display: 'flex',
                                    justifyContent: 'end',
                                  }}
                                >
                                  {/* 2 Days ago  */}
                                  {moment(jobs.modified).fromNow()}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: '12px',
                                  marginTop: '-13px',
                                }}
                              >
                                {jobs?.location || 'N/A'}{' '}
                              </p>{' '}
                            </div>
                          }
                        />
                      </ListItem>
                    </List>

                    {/* <hr /> */}
                  </div>
                ))
              )
                //    :showLoaderJobs ? <Spinner animation="border" role="status">
                //   <span className="visually-hidden">Loading...</span>
                // </Spinner>
                :
                (
                  <div style={{ width: '900px' }}>
                    <center>
                      <Skeleton />
                      <Skeleton count={70} />
                    </center>
                  </div>
                )}
            </div>
          </InfiniteScroll>
        </div>
      </Card>
    </div>
  );
};
export default CompanyJobs;
